module.exports = "https://r.nearpod.com/assets/media/image/chevron-icon-a5d243d333b0c2d7a626baa21cebb7d2.svg";